export default "__VITE_ASSET__59ac9425__"